<template>
  <b-form-group :class="form_group_class+' form-group-lang p-0 m-0'">

    <v-select :class="'form-control '+select_language_class" :options="languages_list" v-model="$i18n.locale" label="name"
      :reduce="(item) => item.val" :clearable="false" :multiple="false" :searchable="false" @input="changeLanguage">
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes"><font-awesome-icon icon="fa-solid fa-chevron-down" /></span>
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
export default {
  props:['form_group_class', 'select_language_class'],
  data() {
    return {
      languages_list: [

        {
          "name": "EN",
          "val": "en"
        },
        {
          "name": "FR",
          "val": "fr"
        },
      ]
    }
  },
  mounted() {
    // this.$refs.myVSelect.open = true
  },
  // watched:{
  //   $i18n.locale(newval){

  //   }    
  // },

  methods: {
    changeLanguage(obj) {
      // console.log(obj)
      this.$i18n.locale = obj
      localStorage.setItem('language', obj)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Language.vue